<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Şube</label>
            <v-select-list v-on:input="clear" :disabled="value.TransferType != 0 && value.TransferType != 3" :options="branches" label="Name" v-model="branch" placeholder="Şube"></v-select-list>
        </div>
        <div class="col-12 mb-1" v-if="value.TransferType == 0 || value.TransferType == 3 || value.TransferType == 1">
            <label class="form-label">Unvan</label>
            <v-select-list :disabled="value.BranchId == null" :options="titles" label="Name" v-model="title" placeholder="Unvan"></v-select-list>
        </div>
        <div class="col-12 mb-1" v-if="value.TransferType == 0 || value.TransferType == 3 || value.TransferType == 2">
            <label class="form-label">Görev Yeri</label>
            <v-select-list :disabled="value.BranchId == null" :options="garages" label="GarageName" v-model="garage" placeholder="Görev Yeri"></v-select-list>
        </div>
        <div class="col-12">
            <label class="form-label">Atama Tarihi</label>
            <v-date-picker v-model="value.StartDate" placeholder="Atama Tarihi"></v-date-picker>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import VehicleOperationsApi from '@/api/vehicle-operations'

export default {
    props:{
        value:Object
    },
    data(){
        return {
            branches:[],
            titles:[],
            garages:[]
        }
    },
    mounted(){
        this.getBranches()
        this.getTitles()
        this.getGarages()
    },
    methods:{
        clear(){
            this.value.TitleId = null
            this.value.GarageId = null
            this.getGarages()
            this.getTitles()
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getTitles(){
            if(this.value.BranchId){
                HumanResourcesParameterApi.EmployeeDepartmentTitle.List(this.value.BranchId).then(res=>{
                    this.titles = res.data.Data
                })
            }
        },
        getGarages(){
            if(this.value.BranchId){
                VehicleOperationsApi.Garage.ListByBranch(this.value.BranchId).then(res=>{
                    this.garages = res.data.Data
                })
            }
        }
    },
    computed:{
        branch:{
            get:function(){ 
                return this.branches.find(t=> t.Id == this.value.BranchId) || null
            },
            set:function(value){
                this.value.BranchId = value?.Id || null
            }
        },
        title:{
            get:function(){ 
                return this.titles.find(t=> t.Id == this.value.TitleId) || null
            },
            set:function(value){
                this.value.TitleId = value?.Id || null
            }
        },
        garage:{
            get:function(){ 
                return this.garages.find(t=> t.Id == this.value.GarageId) || null
            },
            set:function(value){
                this.value.GarageId = value?.Id || null
            }
        },
    }
}
</script>